<template>
  <div
    :id="`ss-sw-${slug}`"
    class="ss-sw"
    :class="{ 'is-changed': isChanged, 'is-flash': flashing }"
    @click="flip"
  >
    <div class="ss-sw__t">
      <b>{{ title }}</b>
      <span v-if="desc">{{ desc }}</span>
    </div>
    <slot name="extra"></slot>
    <ui-switch tone="accent" :value="Boolean(on)" :label="title" @input="flip" />
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

/** Red sa prekidačem (role=switch); cijeli red je površina za dodir. */
export default {
  name: "SetSwitch",
  mixins: [hasSettingsField],
  props: {
    title: { type: String, required: true },
    desc: { type: String, default: "" },
  },
  computed: {
    on() {
      return Boolean(this.value);
    },
  },
  methods: {
    flip() {
      this.write(!this.on, false);
    },
  },
};
</script>
